import { useEffect, useState } from 'react'
import { debug, logError } from 'lib/logging'

export function useDeferredData<T>(promise?: Promise<T> | null): T | undefined {
  let [data, setData] = useState<T | undefined>(undefined)
  useEffect(() => {
    const getData = async () => {
      let d = await promise
      debug(`defer`, `got data`, d)
      if (d) setData(d)
    }
    getData().catch((e) => {
      logError(`error getting deferred data`, e)
      // document.location = `/`
    })
  }, [promise])
  return data
}
